import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import axios from 'axios'

import { fsd } from './main'
import { auth } from './main'
import { storage } from './main'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    loadingEvents: false,
    loadingNews: false,
    loadingPayMethods: false,
    user: null,
    userEvents: null,
    userAds: null,
    events: {
      all: [],
      upcoming: [],
      past: []
    },
    news: [],
    allAttractions: [],
    allRestaurants: [],
    allParks: [],
    selectedAttraction: null,
    selectedRestaurant: null,
    selectedPark: null,
    selectedEvent: null,
    selectedArticle: null,
    isAuth: false,
    authView: 'defaultView',
    organizersView: 'defaultView',
    advertisersView: 'defaultView',
    searchFilter: 'all',
    initSearch: '',
    imageUpload: false,
    currentUploadProgress: 0,
    allAds: [],
    activeAds: [],
    globalAds: [],
    selectedAd: null
  },
  mutations: {
    // User
    setUser (state, user) {state.user = user},
    setIsAuth(state, isAuth) {state.isAuth = isAuth},
    setUserEvents (state, userEvents) {state.userEvents = userEvents},
    setUserAds (state, userAds) {state.userAds = userAds},
    // Global Datas
    initializeStore(state) {this.replaceState(Object.assign(state, JSON.parse(localStorage.getItem('store'))))},
    setPlaces (state, data) {
      let allType = 'all' + data.type.charAt(0).toUpperCase() + data.type.slice(1) + 's'
      state[allType] = data.places
    },
    setNews (state, news) {state.news = news},
    setEvents (state, events) {state.events = events},
    setUpcomingEvents (state, events) {state.upcomingEvents = events},
    setPastEvents (state, events) {state.pastEvents = events},
    setAllAds (state, ads) {state.allAds = ads},
    setActiveAds (state, ads) {state.activeAds = ads},
    setGlobalAds (state, ads) {state.globalAds = ads},
    setSelectedArticle (state, news) {state.selectedArticle = news},
    setSelectedEvent (state, event) {state.selectedEvent = event},
    setSelectedAttraction (state, attraction) {state.selectedAttraction = attraction},
    setSelectedRestaurant (state, restaurant) {state.selectedRestaurant = restaurant},
    setSelectedPark (state, park) {state.selectedPark = park},
    setSelectedAd (state, ad) {state.selectedAd = ad},
    // Views
    setAuthView(state, page) {state.authView = page},
    setOrganizersView(state, page) {state.organizersView = page},
    setAdvertisersView(state, page) {state.advertisersView = page},
    // Utilities
    setLoadingNews(state, isLoading) {state.loadingNews = isLoading},
    setLoadingEvents(state, isLoading) {state.loadingEvents = isLoading},
    setLoadingPayMethods(state, isLoading) {state.loadingPayMethods = isLoading},
    setCurrentUploadProgress(state, progress) {state.currentUploadProgress = progress},
    setSearchFilter(state, searchFilter) {state.searchFilter = searchFilter},
    setInitSearch(state, initSearch) {state.initSearch = initSearch},
    setImageUpload(state, imageUpload) {state.imageUpload = imageUpload},
    setLoading(state, isLoading) {
      state.loading = isLoading
      if (isLoading) {setTimeout(() => {state.loading = false}, 6000)}
    },
  },

  // Actions
  actions: {
    initializeStore({ commit, dispatch }) {
      if (localStorage.getItem('store')) {
        commit('initializeStore')
        if (this.state.isAuth == false) {
          this.state.organizersView = 'defaultView'
          this.state.authView = 'defaultView'
        } else {
          dispatch('getUserData', this.state.user.uid)
        }
      }
    },
    setAuthView({ commit }, data) {
      commit('setAuthView', data)
    },
    setOrganizersView({ commit }, data) {
      commit('setOrganizersView', data)
      window.scrollTo(0, 0)
    },
    setAdvertisersView({ commit }, data) {
      commit('setAdvertisersView', data)
      window.scrollTo(0, 0)
    },

    // User
    login({ commit, dispatch }, data) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        auth.signInWithEmailAndPassword(data.email, data.password)
          .then((loginResult) => {
            commit('setLoading', false)
            if (loginResult.user) {
              if (!loginResult.user.emailVerified) {
                commit('setAuthView', 'verifyEmailView')
                dispatch('checkEmailVerification')
                resolve(loginResult)
              } else {
                dispatch('getUserData', loginResult.user.uid)
                commit('setOrganizersView', 'userView')
                commit('setAdvertisersView', 'userView')
                resolve(loginResult)
              }
            } else {
              commit('setUser', null)
              commit('setIsAuth', false)
              resolve(loginResult)
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            commit('setUser', null)
            commit('setIsAuth', false)
            resolve(error)
          })
      })
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit('setLoading', true)
        auth.signOut().then(() => {
          commit('setLoading', false)
          commit('setUser', null)
          commit('setIsAuth', false)
          commit('setAuthView', 'defaultView')
          commit('setOrganizersView', 'defaultView')
          commit('setAdvertisersView', 'defaultView')
          resolve('success')
        })
        // console.log("logged out")
      })
    },
    register({ commit }, postData) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        auth.createUserWithEmailAndPassword(postData.email, postData.password).then(data => {
          if (data['user']) {
            data.user.sendEmailVerification()
            fsd.collection('users').doc((data.user.uid)).set({
              contact: {
                firstName: postData.contact.firstName,
                lastName: postData.contact.lastName,
                company: postData.contact.company,
                street: postData.contact.street,
                city: postData.contact.city,
                state: postData.contact.state,
                zip: postData.contact.zip
              },
              customer: {
                sources: {
                  data: []
                }
              },
              email: postData.email,
              hasStripe: false,
              approved: false,
              types: {
                organizer: postData.types.organizer,
                advertiser: postData.types.advertiser
              },
              uid: data['user']['uid']
            }).then(() => {
              commit('setLoading', false)
              resolve({status: 'success', message: 'User created successfully'})
            }).catch((error) => {
              commit('setLoading', false)
              resolve({status: 'error', message: error})
            })
          } else {
            commit('setLoading', false)
            resolve({status: 'error', message: data.message})
          }
        }).catch((error) => {
          commit('setLoading', false)
          resolve({status: 'error', message: error.message})
        })
      })
    },
    checkEmailVerification({ commit, dispatch }) {
      console.log('checking email verification')
      if (!auth.currentUser.emailVerified) {
        setTimeout(() => {
          if (auth.currentUser.emailVerified) {
            console.log('email verified')
            commit('setAuthView', 'userView')
          } else {
            console.log('check it again')
            // dispatch('checkEmailVerification')
          }
        }, 3000)
      }
    },
    sendVerificationEmail() {
      auth.currentUser.sendEmailVerification()
    },
    resetPassword({ commit }, email) {
      return new Promise(resolve => {
        commit('setLoading', true)
        auth.sendPasswordResetEmail(email).then(() => {
          commit('setLoading', false)
          resolve('success')
        }).catch((res) => {
          commit('setLoading', false)
          resolve(res)
        })
      })
    },
    getUserData({ commit, dispatch}, uid) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        let userRef = fsd.collection("users").doc(uid)
        userRef.get().then((userData) => {
          commit('setLoading', false)
          if (userData.exists) {
            commit('setUser', userData.data())
            commit('setIsAuth', true)
            commit('setAuthView', 'userView')
            dispatch('getUserEvents', userData.data())
            dispatch('getUserAds', userData.data())
            resolve('success')
          } else {
            console.log("No such user!")
            resolve('error')
          }
        }).catch((error) => {
          commit('setLoading', false)
          console.log(error)
          resolve('error')
        })
      })
    },
    updateUserData({ commit }, user) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let userDoc = fsd.collection('users').doc(user.uid)
        userDoc.update(user).then(() => {
          commit('setLoading', false)
          commit('setUser', user)
          resolve("success")
        })
      })
    },
    getUserByUID({ commit }, uid) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let userRef = fsd.collection('users').doc(uid)
        userRef.get().then((userData) => {
          commit('setLoading', false)
          resolve(userData.data())
        })
      })
    },
    // News
    getNews ({ commit }, searchVal) {
      return new Promise((resolve) => {
        commit('setLoadingNews', true)
        let newsCollection = fsd.collection('news')
        newsCollection.get().then(result => {
          commit('setLoadingNews', false)
          let newsCollection = result
          let newsArray = []
          for (let doc of newsCollection.docs) {
            newsArray.push(doc.data())
          }

          // if (searchVal) {
          //   newsArray = newsArray.filter((item) => {
          //     if (
          //       (item.displayAddress.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
          //       (item.name.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
          //       (item.website.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
          //       (item.url.toLowerCase().indexOf(searchVal.toLowerCase()) > -1)
          //     ) {
          //       return item
          //     }
          //     return
          //   })
          // }

          commit('setNews', newsArray)
          resolve()
        })
      })
    },
    // Events
    getEvents ({ commit }, searchVal) {
      return new Promise((resolve) => {
        commit('setLoadingEvents', true)
        let eventsCollection = fsd.collection('events')
        eventsCollection.get().then(result => {
          let eventsCollection = result
          let eventsArray = []
          let upcomingEvents = []
          let pastEvents = []
          for (let doc of eventsCollection.docs) {
            let event = doc.data()
            eventsArray.push(event)

            if (event.approved) {
              let dateSet = ''
              if (event.dates) {
                for (const date of event.dates) {
                  let now = moment()
                  let eventStart = moment(date.date + " " + date.start)
                  let eventEnd = moment(date.date + " " + date.end)
                  if (eventStart.isAfter(now)) {
                    dateSet = 'upcoming'
                    break
                  } else {
                    if (eventStart.isBefore(now) && eventEnd.isAfter(now)) {
                      dateSet = 'upcoming'
                      break
                    }
                    dateSet = 'past'
                    break
                  }
                }
              }
              if (dateSet == 'upcoming') {
                upcomingEvents.push(event)
              } else if (dateSet == 'past') {
                pastEvents.push(event)
              }
            }
          }

          if (searchVal) {
            upcomingEvents = upcomingEvents.filter((item) => {
              if (
                (item.address.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
                (item.description.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
                (item.title.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
                (item.url.toLowerCase().indexOf(searchVal.toLowerCase()) > -1)
              ) {
                return item
              }
              return
            })
            pastEvents = pastEvents.filter((item) => {
              if (
                (item.address.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
                (item.description.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
                (item.title.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) || 
                (item.url.toLowerCase().indexOf(searchVal.toLowerCase()) > -1)
              ) {
                return item
              }
              return
            })
          }

          upcomingEvents.sort((a, b) => {
            a = new Date(a.dates[0].date)
            b = new Date(b.dates[0].date)
            return a<b ? -1 : a>b ? 1 : 0
          })
          pastEvents.sort((a, b) => {
            a = new Date(a.dates[0].date)
            b = new Date(b.dates[0].date)
            return a>b ? -1 : a<b ? 1 : 0
          })

          let eventObj = {
            all: eventsArray,
            upcoming: upcomingEvents,
            past: pastEvents
          }
          commit('setEvents', eventObj)
          commit('setLoadingEvents', false)
          resolve(eventObj)
        })
      })
    },
    getUserEvents({ commit }, data) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        let upcomingEvents = []
        let pastEvents = []
        if (data) {
          if (data.uid) {
            let userEventsCollection = fsd.collection('events').where('uid', '==', data.uid)
            userEventsCollection.get().then(result => {
              commit('setLoading', false)
              let userEventsCollection = result
              for (let doc of userEventsCollection.docs) {
                let event = doc.data()
                let dateSet = ''
                if (event.dates) {
                  for (const date of event.dates) {
                    if (moment(date['date']).isSame(moment(), 'day')) {
                      // date is today
                      if (moment(date['start']).isAfter(moment())) {
                        // starts later today
                        dateSet = 'upcoming'
                        break
                      } else {
                        // already started
                        if (moment(date['end']).isAfter(moment())) {
                          // is in progress right now
                          dateSet = 'upcoming'
                          break
                        } else {
                          // already ended today
                          dateSet = 'past'
                        }
                      }
                    } else {
                      // date is not today
                      if (moment(date['date']).isAfter(moment(), 'day')) {
                        // date is after today
                        dateSet = 'upcoming'
                        break
                      } else {
                        // date is before today
                        dateSet = 'past'
                      }
                    }
                  }
                }
                if (dateSet == 'upcoming') {
                  upcomingEvents.push(event)
                } else if (dateSet == 'past') {
                  pastEvents.push(event)
                } 
              }
              let userEvents = {
                upcoming: upcomingEvents.sort((a, b) => {
                  a = new Date(a.dates[0].date)
                  b = new Date(b.dates[0].date)
                  return a<b ? -1 : a>b ? 1 : 0
                }),
                past: pastEvents.sort((a, b) => {
                  a = new Date(a.dates[0].date)
                  b = new Date(b.dates[0].date)
                  return a>b ? -1 : a<b ? 1 : 0
                })
              }
              commit('setUserEvents', userEvents)
              resolve(userEvents)
            })
          }
        }
      })
    },
    addEvent({ commit }, eventData) {
      return new Promise(resolve => {
        commit('setLoading', true)
        fsd.collection('events').add({
          title: eventData.event.title,
          address: eventData.event.address,
          dates: eventData.event.dates,
          image: eventData.event.image,
          description: eventData.event.description,
          uid: eventData.uid,
          featured: false,
          approved: false
        })
        .then((result) => {
          commit('setLoading', false)
          eventData.event.eventid = result.id
          eventData.event.uid = eventData.uid
          fsd.collection('events').doc(result.id).set(eventData.event)
          // console.log("Document successfully written!")
          resolve("success")
        })
        .catch((error) => {
          commit('setLoading', false)
          console.error("Error writing document: ", error)
          resolve("Error writing document: " + error)
        })
      })
    },
    updateEvent({ dispatch, commit }, event) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let eventDoc = fsd.collection('events').doc(event.eventid)
        eventDoc.update(event).then(() => {
          dispatch('getUserEvents', this.state.user).then(() => {
            commit('setLoading', false)
            resolve("success")
          })
        })
      })
    },
    removeEvent({ dispatch, commit }, event) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let eventDoc = fsd.collection('events').doc(event.eventid)
        eventDoc.delete().then(() => {
          dispatch('getUserEvents', this.state.user).then(() => {
            commit('setLoading', false)
            resolve("success")
          })
        })
      })
    },

    // Places (attraction, restaurant, park)
    getPlaces ({ commit }, type, searchVal) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        const typePlural = type + 's'
        let placeCollection = fsd.collection(typePlural)
        placeCollection.get().then(result => {
          commit('setLoading', false)
          let placesArray = []
          for (let doc of result.docs) {
            placesArray.push(doc.data())
          }

          if (searchVal) {
            placesArray = placesArray.filter((item) => {
              for (let key of Object.keys(item)) {
                if (item[key].toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
                  return item
                }
              }
            })
          }

          let data = {
            places: placesArray,
            type: type
          }
          commit('setPlaces', data)
          resolve(data)
        })
      })
    },
    getPlaceByID({ commit }, data) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        const typePlural = data.type + 's'
        let selectedPlaceRef = fsd.collection(typePlural).doc(data.uid)
        selectedPlaceRef.get().then(result => {
          commit('setLoading', false)
          const typeRef = 'setSelected' + data.type.charAt(0).toUpperCase() + data.type.slice(1)
          commit(typeRef, result.data())
          resolve()
        })
      })
    },
    addPlace({ dispatch, commit }, placeData) {
      return new Promise(resolve => {
        commit('setLoading', true)
        const typePlural = placeData.type + 's'
        console.log(typePlural)
        fsd.collection(typePlural).add(placeData).then((result) => {
          placeData.uid = result.id
          fsd.collection(typePlural).doc(result.id).set(placeData).then(() => {
            dispatch('getPlaces', placeData.type).then(() => {
              commit('setLoading', false)
              resolve("success")
            })
          })
        })
        .catch((error) => {
          console.error("Error writing document: ", error)
          resolve("Error writing document: " + error)
        })
      })
    },
    updatePlace({ commit }, placeData) {
      return new Promise(resolve => {
        commit('setLoading', true)
        const typePlural = type + 's'
        let placeDoc = fsd.collection(typePlural).doc(place.uid)
        placeDoc.update(place).then(() => {
          dispatch('getPlaces', type).then(() => {
            commit('setLoading', false)
            resolve("success")
          })
        })
      })
    },
    removePlace({ dispatch, commit }, placeData) {
      return new Promise(resolve => {
        commit('setLoading', true)
        const typePlural = placeData.type + 's'
        let placeDoc = fsd.collection(typePlural).doc(placeData.id)
        placeDoc.delete().then(() => {
          dispatch('getPlaces', placeData.type).then(() => {
            commit('setLoading', false)
            resolve("success")
          })
        })
      })
    },

    // Advertisements
    getAllAds ({ commit }) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        let adsCollection = fsd.collection('advertisements')
        adsCollection.get().then(result => {
          let adsCollection = result
          let adsArray = []
          for (let doc of adsCollection.docs) {
            let ad = doc.data()
            if (!ad.color || ad.color == '') {ad.color = 'white'}
            adsArray.push(ad)
          }
          commit('setLoading', false)
          commit('setAllAds', adsArray)
          resolve()
        })
      })
    },
    getActiveAds ({ commit }) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        let adsCollection = fsd.collection('advertisements').where('status', '==', 'Active')
        adsCollection.get().then(result => {
          commit('setLoading', false)
          let adsData = result
          let activeAdsArray = []
          let globalAdsArray = []
          for (let doc of adsData.docs) {
            let ad = doc.data()
            if (!ad.color || ad.color == '') {ad.color = 'w3-white'}
            if (moment(ad.start).isBefore(moment())) {
              if (moment(ad.end).isAfter(moment())) {
                ad.shown = false
                activeAdsArray.push(ad)
                if (ad.placement === 'global')  {
                  globalAdsArray.push(ad)
                }
              }
            }
          }
          for (let i = globalAdsArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [globalAdsArray[i], globalAdsArray[j]] = [globalAdsArray[j], globalAdsArray[i]];
          }
          commit('setActiveAds', activeAdsArray)
          commit('setGlobalAds', globalAdsArray)
          resolve()
        })
      })
    },
    getUserAds({ commit }, data) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        if (data) {
          if (data.uid) {
            let userAdvertisementsCollection = fsd.collection('advertisements').where('uid', '==', data.uid)
            userAdvertisementsCollection.get().then(result => {
              commit('setLoading', false)
              let userAdvertisementsCollection = result
              let ads = []
              for (let doc of userAdvertisementsCollection.docs) {
                let advertisement = doc.data()
                ads.push(advertisement)
              }
              commit('setUserAds', ads)
              resolve(ads)
            })
          } else {
            commit('setLoading', false)
          }
        } else {
          commit('setLoading', false)
        }
      })
    },
    getAdByID({ commit }, id) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        let selectedAdRef = fsd.collection('advertisements').doc(id)
        selectedAdRef.get().then(result => {
          commit('setLoading', false)
          resolve(result.data())
        })
      })
    },
    addAd({ dispatch, commit }, adData) {
      return new Promise(resolve => {
        commit('setLoading', true)
        fsd.collection('advertisements').add(adData).then((result) => {
          adData.id = result.id
          fsd.collection('advertisements').doc(result.id).update(adData).then(() => {
            commit('setLoading', false)
            dispatch('getActiveAds')
            resolve("success")
          })
        })
        .catch((error) => {
          commit('setLoading', false)
          console.error("Error writing document: ", error)
          resolve("Error writing document: " + error)
        })
      })
    },
    updateAd({ dispatch, commit }, ad) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let adDoc = fsd.collection('advertisements').doc(ad.id)
        adDoc.update(ad).then(() => {
          dispatch('getActiveAds').then(() => {
            commit('setLoading', false)
            resolve("success")
          })
        })
      })
    },
    removeAd({ dispatch, commit }, id) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let adDoc = fsd.collection('advertisements').doc(id)
        adDoc.delete().then(() => {
          dispatch('getActiveAds').then(() => {
            dispatch('getUserAds', this.state.user).then(() => {
              commit('setLoading', false)
              resolve("success")
            })
          })
        })
      })
    },

    // Analytics
    addClick({}, clickData) {
      return new Promise(resolve => {
        fsd.collection('clicks').add(clickData).then(() => {
          resolve("success")
        }).catch((error) => {
          resolve("Error writing document: " + error)
        })
      })
    },
    getClicksByAd({ commit }, id) {
      commit('setLoading', true)
      let adClicks = fsd.collection('clicks').where('adID', '==', id)
      let selectedAd = fsd.collection('advertisements').where('id', '==', id)
      selectedAd.get().then((adRef) => {
        commit('setLoading', false)
        let adData = adRef.docs[0].data()
        adClicks.onSnapshot((clickRef) => {
          let clickData = []
          for (let doc of clickRef.docs) {
            let click = doc.data()
            clickData.push(click)
          }
          adData.clickData = clickData
          commit('setSelectedAd', adData)
        })
      })
    },

    // Shared Actions
    updateDoc({ commit }, data) {
      return new Promise(resolve => {
        commit('setLoading', true)
        let doc = fsd.collection(data.type).doc(data.id)
        doc.update(data.doc).then(() => {
          commit('setLoading', false)
          resolve("success")
        })
      })
    },

    // Cloud Storage
    uploadEventImage({ commit }, data) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        const files = data.files
        const uid = data.uid

        const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;'
        const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------'
        const p = new RegExp(a.split('').join('|'), 'g')
        const title = data.title.toString().toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, '-and-') // Replace & with ‘and’
          .replace(/\-([0-9])/g, '') // Replace -[0-9]
          .replace(/[^\w\-]+/g, '') // Remove all non-word characters
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, '') // Trim - from end of text
          
        const extension = files[0].name.split('.').pop()
        const name = title + '.' + extension
        const location = '/events/' + uid + '/' + name
        const ref = storage.ref(location)
        const task = ref.put(files[0])
        task.on('state_changed', (snapshot) => {
          commit('setCurrentUploadProgress', (snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          if ((snapshot.bytesTransferred / snapshot.totalBytes) == 1) {
            setTimeout(() => {commit('setCurrentUploadProgress', 0)}, 1000);
            return
          }
          if ((snapshot.bytesTransferred / snapshot.totalBytes) == 0) {
            commit('setCurrentUploadProgress', 1)
          }
        }, (error) => {
          console.log(error)
        }, () => {
          task.snapshot.ref.getDownloadURL().then((downloadURL) => {
            commit('setLoading', false)
            resolve({
              message: 'success',
              imageURL: downloadURL
            })
          })
        })
      })
    },
    uploadAdImage({ commit }, data) {
      return new Promise((resolve) => {
        commit('setLoading', true)
        const files = data.files
        const type = data.type
        const uid = data.uid
        const name = data.name
        const location = uid + '/ads/' + name
        const ref = storage.ref(location)
        
        const task = ref.put(files[0])
        task.on('state_changed', (snapshot) => {
          commit('setCurrentUploadProgress', (snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          if ((snapshot.bytesTransferred / snapshot.totalBytes) == 1) {
            setTimeout(() => {commit('setCurrentUploadProgress', 0)}, 1000);
            return
          }
          if ((snapshot.bytesTransferred / snapshot.totalBytes) == 0) {
            commit('setCurrentUploadProgress', 1)
          }
        }, (error) => {
          console.log(error)
        }, () => {
          task.snapshot.ref.getDownloadURL().then((downloadURL) => {
            commit('setLoading', false)
            resolve({
              message: 'success',
              imageURL: downloadURL
            })
          })
        })
      })
    },

    // Stripe
    stripeConnect({}) {
      window.open('https://server.daytonalocal.com/connect', "_self")
    },
    retrieveToken({}, stripeCode) {
      return new Promise(resolve => {
        commit('setLoading', true)
        this.http.post('https://us-central1-daytona-local.cloudfunctions.net/getToken', stripeCode).subscribe(
          res => {
            commit('setLoading', false)
            resolve(res);
          },
          err => {
            console.log("Error occured:");
            console.log(err);
          }
        );
      });
    },
    getStripeAccount({ commit }, acctId) {
      return new Promise(resolve => {
        commit('setLoading', true)
        this.http.post('https://us-central1-daytona-local.cloudfunctions.net/getStripeAccount', acctId).subscribe(
          res => {
            commit('setLoading', false)
            if (acctId == res['id']) {
              resolve(res);
            } else {
              resolve('not same acct id');
            }
          },
          err => {
            console.log("Error occured:");
            console.log(err);
          }
        );
      });
    },
    sendEmail({}, data) {
      return new Promise((resolve) => {
        console.log(data)
        let postData = {
          email: data.email,
          type: data.type
        }
        axios.post('https://us-central1-daytona-local.cloudfunctions.net/sendEmail', postData).then((response) => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          console.log(error)
          resolve(error)
        })
      })
    }
  }
})
